export enum AblyMessageOrigin {
  USER = 'user',
  ADMIN = 'admin'
}